<h2 mat-dialog-title>Install Wordpress</h2>
<p class="subtitle">{{ data.domain }}</p>
<mat-dialog-content>
  <form [formGroup]="wordpressForm">
    <app-input-field
      label="WP Admin Username"
      formControlName="user"
      [errorMessages]="wpErrors['user']"
    ></app-input-field>

    <app-input-field
      label="WP Admin Password "
      type="password"
      autocomplete="new-password"
      formControlName="password"
      [errorMessages]="wpErrors['password']"
    ></app-input-field>

    <app-input-field
      label="Email"
      formControlName="email"
      [errorMessages]="wpErrors['email']"
    ></app-input-field>

    <app-input-field
      label="Install in subdirectory"
      hint="Leave empty to install in root directory."
      formControlName="directory"
      prefixText="/public_html/"
    ></app-input-field>

    <app-input-field
      label="Database"
      hint="When installing in a subdirectory, select new database"
      formControlName="databaseId"
      type="select"
      [options]="databases()"
    ></app-input-field>

    <div class="checkboxes">
      @if (wordpressForm.controls.directory.value.length) {
        <mat-checkbox formControlName="forceInstall"
          >Ignore any existing WordPress installations</mat-checkbox
        >
      }
      <mat-checkbox formControlName="enableRedisCache">Enable Redis Cache</mat-checkbox>
      <mat-checkbox formControlName="enableW3TotalCache">Install W3 Total Cache</mat-checkbox>
      <mat-checkbox formControlName="enableWooCommerce">Install WooCommerce</mat-checkbox>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="filled" (click)="submit()" [disabled]="wordpressForm.invalid">
    Install WordPress
  </button>
  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
